"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _admin = require("../reducers/admin.js");
var _admin2 = require("../selectors/admin.js");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _default = exports["default"] = function _default() {
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var dispatch = (0, _reactRedux.useDispatch)();
  var params = (0, _reactRouterDom.useParams)();
  var deploymentId = params.deploymentId || 0;
  var currentAssignmentId = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin2.getCurrentAssignmentId)(state.assignment.admin);
  });
  var projectDeployments = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin2.getCurrentProjectDeployments)(state.assignment.admin);
  });
  var parsedDeployment = projectDeployments.find(function (d) {
    return d.deploymentId === Number(deploymentId);
  });
  (0, _react.useEffect)(function () {
    setLoading(true);
    if (parsedDeployment && parsedDeployment.assignment.assignmentId !== currentAssignmentId) {
      dispatch((0, _admin.setCurrentAssignmentIdOnly)(parsedDeployment.assignment.assignmentId));
    }
    dispatch((0, _admin.setCurrentDeploymentId)(deploymentId));
    setLoading(false);
  }, [currentAssignmentId, deploymentId]);
  return loading;
};